// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --input-height: 2.4rem;
  --select-wrapper-height: auto;
}

.select-wrapper {
  position: relative;
  z-index: 999;
  height: var(--select-wrapper-height);
}
.select-wrapper.disabled {
  background: #f4f4f4;
  cursor: not-allowed;
}
.select-wrapper.disabled .select {
  color: #95999d;
}
.select-wrapper input {
  width: 100%;
  height: var(--input-height);
  border-radius: 0.25rem;
  border: 1px solid #ced4da;
  font-weight: 400;
  color: #495057;
  padding-left: 1rem;
  font-size: 1rem;
  transition: 0.2s;
}
.select-wrapper input:focus {
  border-color: #8f939e;
}
.select-wrapper .select {
  position: relative;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  width: 100%;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  height: calc(1.5em + 0.75rem + 2px);
  transition: 0.3s;
  padding-left: 1rem;
  display: flex;
  align-items: center;
}
.select-wrapper .select.error {
  border-color: #dc3545;
}
.select-wrapper .select .selected {
  max-width: calc(100% - 2rem);
}
.select-wrapper .select i {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.9rem;
  transition: 0.3s ease-in-out;
  transform-origin: center;
}
.select-wrapper .selected,
.select-wrapper .option {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.select-wrapper .options {
  max-height: 0;
  width: 100%;
  transition: 0.5s;
  position: absolute;
  top: calc(1.5em + 0.75rem + 2px);
  overflow: hidden;
  z-index: 999;
  background: transparent;
  border: 1px solid transparent;
}
.select-wrapper .options .option {
  padding: 0.5em;
  transition: 0.3s;
  cursor: pointer;
}
.select-wrapper .options .option p {
  margin: 0;
  font-size: 0.9em;
}
.select-wrapper .options .option .title {
  font-weight: 700;
}
.select-wrapper .options .option .subtitle {
  font-weight: 300;
  margin-bottom: 0;
}
.select-wrapper .options .option:hover {
  background: #ff0059;
  color: #fff;
}
.select-wrapper .options .option.disabled {
  pointer-events: none;
  opacity: 75%;
}
.select-wrapper:focus {
  border-color: #8f939e;
}
.select-wrapper.open {
  z-index: 9999;
}
.select-wrapper.open .select i {
  transform: translateY(-50%) rotate(180deg);
}
.select-wrapper.open .options {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ced4da;
  background: #fff;
  z-index: 999;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
}
.select-wrapper.open .options .option {
  z-index: 999;
  position: relative;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
